import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { GoldCanvas } from './GoldScene';
import './Sections.css';

export default function HeroSection() {
  const ref = useRef();
  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
      tl.fromTo('.hero-badge-el', { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 1, delay: 0.15 })
        .fromTo('.hero-h1', { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1.1 }, '-=0.7')
        .fromTo('.hero-sub-el', { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 0.9 }, '-=0.6')
        .fromTo('.hero-actions-el', { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 0.9 }, '-=0.5')
        .fromTo('.hero-stats-el', { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.8 }, '-=0.4');
    }, ref);
    return () => ctx.revert();
  }, []);

  const go = (e, id) => { e.preventDefault(); document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' }); };

  return (
    <section className="sec hero-sec" ref={ref}>
      {/* 3D gold — FULL BACKGROUND */}
      <div className="hero-3d-bg">
        <GoldCanvas follow={true} cam={[0, 0, 7]} />
      </div>
      <div className="hero-overlay" />

      <div className="hero-inner">
        <div className="hero-badge-el pill">Trading Education #1 di Malaysia</div>
        <h1 className="hero-h1">
          From <span className="gold-grad">$50</span> to <span className="gold-grad">$1,000</span>?
          <br />Not a Dream If You <em>Trade Like a Pro.</em>
        </h1>
        <p className="hero-sub-el">
          Rahsia trading emas yang telah membantu ratusan trader Malaysia mencapai
          konsistensi profit &mdash; semuanya didedahkan dalam satu buku oleh <strong>Adam Danish</strong>.
        </p>
        <div className="hero-actions-el">
          <a href="#order-form" className="btn-gold" onClick={(e) => go(e, '#order-form')}>
            Dapatkan Buku TLP Sekarang
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </a>
          <a href="#offer" className="btn-ghost" onClick={(e) => go(e, '#offer')}>Ketahui Lebih Lanjut</a>
        </div>
        <div className="hero-stats-el">
          <div className="hs"><span className="hs-num">500+</span><span className="hs-label">Pembaca</span></div>
          <span className="hs-div" />
          <div className="hs"><span className="hs-num">4.9/5</span><span className="hs-label">Rating</span></div>
          <span className="hs-div" />
          <div className="hs"><span className="hs-num">100%</span><span className="hs-label">Money-Back</span></div>
        </div>
      </div>

      <div className="scroll-hint"><div className="scroll-mouse"><div className="scroll-dot" /></div></div>
    </section>
  );
}
